export type LexicalNode = { type: string; version: number; [k: string]: unknown }

export type LexicalRoot = { root: LexicalNode & { children: LexicalNode[] } }

const textLen = (node: LexicalNode): number => {
  const own = typeof node.text === "string" ? node.text.length : 0
  const kids = Array.isArray(node.children) ? (node.children as LexicalNode[]).reduce((n, c) => n + textLen(c), 0) : 0
  return own + kids
}

export const richTextLength = (data: LexicalRoot): number => textLen(data.root)

const extractText = (node: LexicalNode): string => {
  const own = typeof node.text === "string" ? node.text : ""
  const kids = Array.isArray(node.children) ? (node.children as LexicalNode[]).map(extractText).join("") : ""
  return own + kids
}

export const richTextExcerpt = (data: LexicalRoot, maxLen: number): string | undefined => {
  const full = extractText(data.root)
  if (full.length <= maxLen) return undefined
  const cut = full.lastIndexOf(" ", maxLen)
  return full.slice(0, cut > 0 ? cut : maxLen) + "..."
}
